import { Container } from "@mui/material";
import { FC } from "react";

import { FeedbackForm } from "../components";

export const Feedback: FC = () => {
  return (
    <Container sx={{ flexGrow: 1 }}>
      <FeedbackForm />
    </Container>
  );
};
